import React from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './StyledHtml.styl';

const cx = classNames.bind(styles);

const StyledHtml = ({ className, html }) => {
  return (
    <div className={cx(styles.StyledHtml, className)} dangerouslySetInnerHTML={{ __html: html }} />
  );
};

export default StyledHtml;

StyledHtml.defaultProps = {
  className: '',
};

StyledHtml.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string.isRequired,
};
